import Service from './service';

export default abstract class Command<Param = any> extends Service<any, Param> {
  readonly = false;
}
